export default __webpack_public_path__ + "static/media/jazz.8820f836.gif";